<template>
    <div
        class="profile"
        :class="{ 'before-confirm': from === 'chatUser' && confirmedStatus !== 'confirmed' }"
        v-if="chatUser && profile"
    >
        <div class="detail">
            <!-- <h3 class="h3">
                <i class="material-icons m-r-4">work</i>
                직장/직업 정보
            </h3> -->

            <!-- Career -->
            <div class="item-container" v-for="(item, idx) in profile.company" :key="idx">
                <div class="item">
                    <div class="key">직업</div>
                    <div class="value">
                        <span class="seperator-slash">{{ item.job_name }}</span>
                        <!-- <span class="seperator-slash">{{ getEmploymentStatus(item.employment_type) }}</span> -->
                    </div>
                </div>

                <div class="item">
                    <div class="key">직장</div>
                    <div class="value">
                        <span class="seperator-slash">{{ item.job_category_name }}</span>
                    </div>
                </div>

                <div class="item">
                    <div class="key">직장명</div>
                    <div class="value">
                        <div class="career_value">
                            {{
                                item.company_name_modified
                                    ? `${profile.company[0].company_name} (${item.company_name_modified})`
                                    : item.company_name
                            }}
                            <br />({{ item.region_shorten
                            }}<span v-if="item.show_region_shorten === 0" class="badge-manager-only">부분공개</span>)
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="detail">
            <!-- Educational -->
            <!-- <h3 class="h3">
                <i class="material-icons m-r-4">school</i>
                학력정보
            </h3> -->

            <!-- <div class="item-container m-b-8">
                <span class="title-badge-purple f-15">표시될 학교명 : {{ universityModified }}</span>
            </div> -->
            <div class="item">
                <div class="key" v-html="'학력'" />
                <div class="value pre-line">
                    {{ profile.bachelor_u_name }}
                    {{ profile.bachelor_m_name ? `(${profile.bachelor_m_name})` : `(-)` }}
                    {{ profile.master_u_name ? `\n(석사) ${profile.master_u_name}` : '' }}
                    {{ profile.doctor_u_name ? `\n(박사) ${profile.doctor_u_name}` : '' }}
                </div>
            </div>
        </div>

        <div class="detail">
            <!-- Income -->
            <!-- <h3 class="h3">
                <i class="material-icons m-r-4">paid</i>
                소득정보
            </h3> -->

            <div class="item" v-for="item in incomeProfile" :key="item.key" v-show="item.value">
                <div class="key" v-html="item.key" />
                <!-- <div class="value">
                    <span>{{ item.value }}</span>
                    <span v-if="item.selective" class="badge-manager-only">매니저만 </span>
                </div> -->

                <div class="value">
                    <div>
                        <div v-if="item.value_range">
                            {{ item.value_range }}
                        </div>
                        <div class="income_value">
                            {{ item.value }}
                            <!-- <span v-if="item.selective === 0 || item.selective === false" class="badge-manager-only"
                                >매니저만</span
                            > -->
                            <div v-if="item.description">{{ item.description }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="detail">
            <!-- Personal -->
            <!-- <h3 class="h3">
                <i class="material-icons m-r-4">person</i>
                인적사항
            </h3> -->

            <div class="item" v-for="item in personalProfile" :key="item.key">
                <div class="key" v-html="item.key" />
                <div class="value">
                    <span class="personal_value" :class="item.value === '재혼' ? 'bold' : ''">{{ item.value }}</span>
                    <span v-if="item.selective" class="badge-manager-only">매니저만 </span>
                    <div v-if="item.description">{{ item.description }}</div>
                </div>
            </div>
        </div>

        <PersonalStory :user="chatUser" />
        <!-- <Career :profile="profile" />
        <Educational :profile="profile" />
        <Personal :profile="profile" />
        <Income :profile="profile" />
        <Family :profile="profile" />
        <Marriage :profile="profile" /> -->
        <!-- <UserIntro :profile="profile" /> -->
        <!-- <LikeTags :user="chatUser" /> -->
        <JudgingBtns :profile="profile" :chatUser="chatUser" />
    </div>
</template>

<script>
// import userService from '@/services/user'
// import Personal from '@/routes/chat/chatroom/components/Personal'
import PersonalStory from '@/routes/chat/chatroom/components/PersonalStory'
// import Educational from '@/routes/chat/chatroom/components/Educational'
// import Career from '@/routes/chat/chatroom/components/Career'
// import Marriage from '@/routes/chat/chatroom/components/Marriage'
// import Income from '@/routes/chat/chatroom/components/Income'
// import LikeTags from '@/components/common/LikeTags'
// import UserIntro from '@/components/common/UserIntro'
// import Family from '@/routes/chat/chatroom/components/Family'
import JudgingBtns from '@/routes/chat/chatroom/components/JudgingBtns'

export default {
    name: 'IntroUserProfiles',
    components: {
        // Personal,
        PersonalStory,
        // Educational,
        // Career,
        // Income,
        // Marriage,
        // LikeTags,
        // UserIntro,
        // Family,
        JudgingBtns,
    },
    props: ['chatUser', 'profile', 'from'],
    data: () => ({
        // university: null,
        // universityModified: null,
    }),
    watch: {
        chatUser() {
            // this.personalProfile()
            // this.personalProfile()
            // this.incomeProfile()
        },
        // profile: {
        //     deep: true,
        //     immediate: true,
        //     // handler(newProfile) {
        //     //     this.initUniversities(newProfile.school.id)
        //     // },
        // },
    },
    computed: {
        confirmedStatus() {
            return (this.profile || {}).status
        },
        personalProfile() {
            if (!(this.profile && this.profile.privacy_setting)) return []

            const items = [
                {
                    id: 1,
                    key: '종교',
                    value: (this.profile || {}).religion_name || null,
                    selective: !this.profile.privacy_setting.show_religion_name,
                },
                {
                    id: 2,
                    key: 'MBTI',
                    value: (this.profile || {}).mbti,
                    selective: !this.profile.privacy_setting.show_mbti,
                },
                {
                    id: 3,
                    key: '흡연',
                    value: (this.profile || {}).smoking ? '흡연' : '비흡연',
                    selective: !this.profile.privacy_setting.show_smoking,
                },
                {
                    id: 4,
                    key: '결혼 경험',
                    value: (this.profile || {}).marry === 1 ? '재혼' : '초혼',
                    selective: false,
                },
                {
                    id: 5,
                    key: '결혼 계획',
                    value: (this.profile || {}).marry_plan || null,
                    selective: !this.profile.privacy_setting.show_marry_plan,
                },
                // {
                //     id: 2,
                //     key: '운동빈도',
                //     value: (this.profile || {}).exercise_freq,
                //     selective: !this.profile.privacy_setting.show_exercise_freq,
                // },
                // {
                //     id: 31,
                //     key: '운동종류',
                //     value: (this.profile || {}).exercise_type,
                //     selective: !this.profile.privacy_setting.show_exercise_type,
                // },
                // {
                //     id: 6,
                //     key: '음주여부',
                //     value: (this.profile || {}).drink_freq,
                //     selective: !this.profile.privacy_setting.show_drink_freq,
                // },
                // {
                //     id: 8,
                //     key: '선호주종',
                //     value: (this.profile || {}).drink_style,
                //     selective: !this.profile.privacy_setting.show_drink_style,
                // },
                // {
                //     id: 11,
                //     key: '반려동물',
                //     value: (this.profile || {}).pet,
                //     selective: !this.profile.privacy_setting.show_pet,
                // },
                // {
                //     id: 11,
                //     key: '건강',
                //     value: (this.profile || {}).health_status ? '좋지 않음' : '좋음',
                //     description: (this.profile || {}).health_status ? this.profile.health_detail : null,
                //     selective: !this.profile.privacy_setting.show_health_status,
                // },
            ]

            return items.filter(item => item.value)
        },

        getHouseValue() {
            if (!(this.profile && this.profile.privacy_setting)) return []

            let houseOwner = ''
            switch (this.profile.house_owner) {
                case 0:
                    houseOwner = '본인소유'
                    break
                case 1:
                    houseOwner = '부모님소유'
                    break
                case 2:
                    houseOwner = '형제소유'
                    break
                default:
                    houseOwner = ''
                    break
            }

            const items = [this.profile.house_style, this.profile.house_payment, houseOwner]
            return items.filter(item => item).join(' /  ')
        },
        incomeProfile() {
            if (!(this.profile && this.profile.privacy_setting)) return []

            const items = [
                {
                    id: 1,
                    key: '연소득',
                    value: this.profile.income ? this.$krwParsed(this.profile.income) : '소득없음',
                    value_range:
                        this.profile.privacy_setting.show_income === 2
                            ? this.$profile.moneyRangeParsed(this.profile.income)
                            : null,
                    selective: this.profile.privacy_setting.show_income,
                },
                {
                    id: 2,
                    key: '자산',
                    value: this.profile.asset ? this.$krwParsed(this.profile.asset) : '자산없음',
                    value_range:
                        this.profile.privacy_setting.show_asset === 2
                            ? this.$profile.assetRangeParsed(this.profile.asset)
                            : null,
                    description: this.profile.asset_detail,
                    selective: this.profile.privacy_setting.show_asset,
                },
                {
                    id: 3,
                    key: '부동산(주거)',
                    value: this.getHouseValue,
                    selective: this.profile.privacy_setting.show_house_owner,
                },
                {
                    id: 4,
                    key: '재테크',
                    value: this.profile.finance || null,
                },
                {
                    id: 5,
                    key: '차량',
                    value: this.profile.car_type ? `${this.profile.car_type} (${this.profile.car_model})` : null,
                },
            ]
            return items.filter(item => item.value)
        },

        getEmploymentStatus() {
            return status => {
                let content = ''
                switch (status) {
                    case 0:
                        content = '정규직'
                        break
                    case 1:
                        content = '계약직'
                        break
                    case 2:
                        content = '파견직'
                        break
                    case 3:
                        content = '위촉직'
                        break
                    case 4:
                        content = '기타'
                        break
                }
                return content
            }
        },
        // userUniv() {
        //     return ['bachelor', 'master', 'doctor'].filter(type => this.profile[`${type}_u_name`])
        // },
        // univItems() {
        //     const items = []
        //     if (!this.profile.privacy_setting) return []

        //     this.userUniv.forEach(sType => {
        //         items.push({
        //             type: sType,
        //             name: this.profile[`${sType}_u_name`],
        //             college: this.profile[`${sType}_c_name`],
        //             show_college: this.profile.privacy_setting[`show_${sType}_c_name`],
        //             major: this.profile[`${sType}_m_name`],
        //             show_major: this.profile.privacy_setting[`show_${sType}_m_name`],
        //             status: this.profile[`${sType}_status`],
        //             start: this.profile[`${sType}_start`],
        //             end: this.profile[`${sType}_end`],
        //         })
        //     })

        //     return items
        // },
        // highSchoolItem() {
        //     // if (this.profile.profile_setting.show_high_school_name) {
        //     if (!this.profile.privacy_setting) return {}

        //     return {
        //         type: 'high_school',
        //         name: this.profile.high_school_name,
        //         show_high_school: this.profile.privacy_setting.show_high_school_name,
        //         status: this.profile.high_school_status,
        //         start: this.profile.high_school_start,
        //         end: this.profile.high_school_end,
        //     }
        // },
        // onlySchool() {
        //     return !(this.univItems.length || this.profile.high_shcool_name)
        // },
        // getSchoolStatus() {
        //     return status => {
        //         let content = ''
        //         switch (status) {
        //             case 0:
        //                 content = '졸업'
        //                 break
        //             case 1:
        //                 content = '수료'
        //                 break
        //             case 2:
        //                 content = '중퇴'
        //                 break
        //             case 3:
        //                 content = '재학'
        //                 break
        //             case 4:
        //                 content = '휴학'
        //                 break
        //             case 5:
        //                 content = '편입재학'
        //                 break
        //             case 6:
        //                 content = '편입졸업'
        //                 break
        //             default:
        //                 content = false
        //         }
        //         return content
        //     }
        // },
        // getSchoolType() {
        //     return type => {
        //         let content = ''
        //         switch (type) {
        //             case 'doctor':
        //                 content = '대학교(박사)'
        //                 break
        //             case 'master':
        //                 content = '대학교(석사)'
        //                 break
        //             case 'bachelor':
        //                 content = '대학교(학사)'
        //                 break
        //         }
        //         return content
        //     }
        // },
    },
    methods: {
        // onFailClick() {
        //     this.$modal.custom({
        //         component: 'ModalChooseReason',
        //     })
        // },
        // async initUniversities(schoolId) {
        //     if (schoolId === 1) {
        //         this.university = await userService.universities({
        //             schoolTypeId: null,
        //             name: this.profile.doctor_u_name,
        //         })
        //     } else if (schoolId < 4) {
        //         this.university = await userService.universities({
        //             schoolTypeId: null,
        //             name: this.profile.master_u_name,
        //         })
        //     } else if ([4, 5, 7].includes(schoolId)) {
        //         this.university = await userService.universities({
        //             schoolTypeId: null,
        //             name: this.profile.bachelor_u_name,
        //         })
        //     }
        //     this.updateUniversityModified()
        // },
        // updateUniversityModified() {
        //     if (this.university && this.university.length > 0) {
        //         if (this.university[0].spec_grade >= 5) {
        //             if (
        //                 [
        //                     '해외 명문대(세계 100위권)',
        //                     '해외명문대(세계 30위권)',
        //                     '해외명문대',
        //                     '아이비리그',
        //                     '해외대',
        //                 ].includes(this.university[0].utype)
        //             ) {
        //                 this.universityModified = `${this.university[0].name} ${this.university[0].utype}) ${
        //                     this.profile.school.id === 1 ? '(박사)' : this.profile.school.id < 4 ? '(석사)' : ''
        //                 }`
        //             } else {
        //                 this.universityModified = `${this.university[0].name} ${
        //                     this.profile.school.id === 1 ? '(박사)' : this.profile.school.id < 4 ? '(석사)' : ''
        //                 }`
        //             }
        //         } else if (this.university[0].spec_grade === 4) {
        //             this.universityModified = `${this.university[0].utype} ${
        //                 this.profile.school.id === 1 ? '(박사)' : this.profile.school.id < 4 ? '(석사)' : ''
        //             }`
        //         } else {
        //             if (this.university[0].utype === '해외대') {
        //                 this.universityModified = `${this.university[0].utype} ${
        //                     this.profile.school.id === 1 ? '(박사)' : this.profile.school.id < 4 ? '(석사)' : ''
        //                 }`
        //             } else {
        //                 this.universityModified = null
        //             }
        //         }
        //     }
        // },
    },
}
</script>

<style lang="scss">
.profile {
    position: relative;
    margin-top: 16px;
    &.before-confirm {
        i {
            color: white !important;
        }
        color: white !important;

        .title {
            color: white;
        }

        .item {
            .key {
                color: $grey-03;
            }
            .value {
                color: white !important;
            }
        }
        .like-tags {
            .tag-container {
                .title {
                    color: white;
                }
                .tag-content {
                    background: #111111 !important;
                    color: white !important;
                }
            }
        }
    }
    .detail {
        border-top: 1px solid #f1f2f4;
        padding: 12px 0px;
        .item {
            display: flex;

            margin-bottom: 8px;
            &:last-child {
                margin-bottom: 0px;
            }

            .key {
                width: 20%;
                min-width: 80px;
            }
            .value {
                color: black;
                width: 80%;
            }

            .personal_value.bold {
                font-weight: bold;
                color: #ff3d6b;
            }
        }
    }
}
.judging-btns {
    .title {
        font-weight: 600;
        font-size: 18px;
        margin-bottom: 10px;
        margin-top: 10px;
    }
}
.profile-confirm {
    .profile-success-btn {
        width: 210px;
        height: 40px;
        background-color: #55efc4;
        color: black;
        font-size: 12px;
        border-radius: 8px;
        cursor: pointer;
    }
    .profile-failed-btn {
        width: 210px;
        height: 40px;
        background-color: #ffeaa7;
        color: black;
        font-size: 12px;
        border-radius: 8px;
        cursor: pointer;
    }
    .user-detail-btn {
        width: 210px;
        height: 40px;
        background-color: #8a74ff;
        color: white;
        font-size: 12px;
        border-radius: 8px;
        cursor: pointer;
    }
    .user-failed-btn {
        width: 210px;
        height: 40px;
        background-color: palevioletred;
        color: white;
        font-size: 12px;
        border-radius: 8px;
        cursor: pointer;
    }
}

.h3 {
    color: #646468;
}
.seperator-slash:not(:last-child)::after {
    content: '/';
    margin: 0 2px;
}
.key {
    color: #646468;
}
.instant-chat {
    .h3 {
        color: #fff;
    }
    .key {
        color: #fff;
    }
    .personal_value {
        color: #fff;
    }
}
.before-confirm {
    .h3 {
        color: #fff;
    }
}
</style>
